module.exports = __webpack_public_path__ + "static/media/selo-moodys.7f7c9637.png";